import { TIPTAP_PACKAGE_PREFIX } from '@cli-constants/deps.js'

export function isTiptapPackageName(name: string): boolean {
  return name.startsWith(TIPTAP_PACKAGE_PREFIX)
}
